export default __webpack_public_path__ + "static/media/83_photo.fd9aacb2.jpg";